module.exports = __webpack_public_path__ + "static/media/Badge_SvgSiteConnecte_disabled.72d104a3.svg";